if (!customElements.get('how-to-use-steps')) {
  class HowToUseSteps extends HTMLElement {
    connectedCallback() {
      this.player = this.querySelector('[data-how-to-player]');
      this.playerSlot = this.querySelector('[data-how-to-player-slot]');
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.clickPlaying = false;
      this.hoverTimer = 0;

      if (!this.player || !this.playerSlot) return;

      this.player.addEventListener('pointerenter', this.onPointerEnter, { signal });
      this.player.addEventListener('pointerleave', this.onPointerLeave, { signal });
      this.addEventListener('click', this.onClick, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.clearHoverTimer();
      this.stopVideo();
    }

    onPointerEnter = () => {
      if (this.clickPlaying) return;
      this.clearHoverTimer();
      this.hoverTimer = window.setTimeout(() => {
        if (this.clickPlaying) return;
        this.playVideo({ muted: true, fromClick: false });
      }, 160);
    };

    onPointerLeave = () => {
      this.clearHoverTimer();
      if (this.clickPlaying) return;
      this.stopVideo();
    };

    onClick = (event) => {
      if (!event.target.closest('[data-how-to-player]')) return;
      event.preventDefault();

      if (this.clickPlaying) {
        this.clickPlaying = false;
        this.stopVideo();
        return;
      }

      this.clearHoverTimer();
      this.playVideo({ muted: false, fromClick: true });
    };

    /**
     * Plays the how-to video inside the cover box.
     * @param {{ muted: boolean, fromClick: boolean }} options
     */
    playVideo({ muted, fromClick }) {
      const url = this.player?.dataset.videoUrl;
      if (!url || !this.playerSlot) return;

      this.clickPlaying = fromClick;
      this.player.classList.add('is-playing');
      this.playerSlot.replaceChildren();

      const youtubeId = this.getYoutubeId(url);
      if (youtubeId) {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=${muted ? 1 : 0}&playsinline=1&rel=0`;
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = 'How to use video';
        if (!fromClick) iframe.classList.add('is-hover-play');
        this.playerSlot.appendChild(iframe);
        return;
      }

      const video = document.createElement('video');
      video.src = url;
      video.autoplay = true;
      video.playsInline = true;
      video.muted = muted;
      video.controls = fromClick;
      this.playerSlot.appendChild(video);
      video.play().catch(() => {});
    }

    stopVideo() {
      this.clickPlaying = false;
      this.player?.classList.remove('is-playing');
      this.playerSlot?.replaceChildren();
    }

    clearHoverTimer() {
      window.clearTimeout(this.hoverTimer);
      this.hoverTimer = 0;
    }

    /**
     * @param {string} url
     * @returns {string}
     */
    getYoutubeId(url) {
      const match = url.match(
        /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/,
      );
      return match ? match[1] : '';
    }
  }

  customElements.define('how-to-use-steps', HowToUseSteps);
}
